// Innovenza is served as a pure static site from public/index.html.
// React is kept only because CRA/supervisor expects it; it renders nothing
// so the static HTML below the #root mount point is the visible page.
export default function App() {
  return null;
}
